var React = require('react');

function EmailIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9ba8f1","d":"M502.3,126.8c3.9-3.1,9.7-0.2,9.7,4.7V336c0,26.5-21.5,48-48,48H48c-26.5,0-48-21.5-48-48V131.6c0-5,5.7-7.8,9.7-4.7\n\tc22.4,17.4,52.1,39.5,154.1,113.6c21.1,15.4,56.7,47.8,92.2,47.6c35.7,0.3,72-32.8,92.3-47.6C450.3,166.4,479.9,144.2,502.3,126.8z\n\t M256,256c23.2,0.4,56.6-29.2,73.4-41.4c132.7-96.3,142.8-104.7,173.4-128.7c5.8-4.5,9.2-11.5,9.2-18.9V48c0-26.5-21.5-48-48-48H48\n\tC21.5,0,0,21.5,0,48v19c0,7.4,3.4,14.3,9.2,18.9c30.6,23.9,40.7,32.4,173.4,128.7C199.4,226.8,232.8,256.4,256,256L256,256z"}));
}

EmailIcon.defaultProps = {"version":"1.1","id":"svg__email-icon","x":"0px","y":"0px","viewBox":"0 0 512 384","style":{"enableBackground":"new 0 0 512 384"},"xmlSpace":"preserve"};

module.exports = EmailIcon;

EmailIcon.default = EmailIcon;
